import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup"


const CounterSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run once
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <>
      {/* Start Counter Section */}
      <section ref={sectionRef} className="section counter-section-fifteen pt-0">
        <div className="container">
          <div className="row row-gap-4">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div
                className="counter-item-fifteen wow fadeInUp"
                data-wow-duration="1s"
              >
                <h4 className="count">
                  <span className="count-digit">{isVisible && (
                    <CountUp className="number" end={5000} duration={2} />
                  )}</span>+
                </h4>
                <p>Happy Clients</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div
                className="counter-item-fifteen wow fadeInUp"
                data-wow-duration="1s"
              >
                <h4 className="count">
                  <span className="count-digit">{isVisible && (
                    <CountUp className="number" end={1200} duration={2} />
                  )}</span>+
                </h4>
                <p>Counseling Completed</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div
                className="counter-item-fifteen wow fadeInUp"
                data-wow-duration="1s"
              >
                <h4 className="count">
                  <span className="count-digit">{isVisible && (
                    <CountUp className="number" end={150} duration={2} />
                  )}</span>K
                </h4>
                <p>Awards Won</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div
                className="counter-item-fifteen wow fadeInUp"
                data-wow-duration="1s"
              >
                <h4 className="count">24/7</h4>
                <p>Customer Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Counter Section */}
    </>

  )
}

export default CounterSection